import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import M from "materialize-css";

import { useAuth } from "../hooks/usehooks.com/use-auth";

import cavsLogo from "../../public/img/cavs-logo.png";
import TermsBannerComponent from "../components/shared/TermsBannerComponent";

export default function Login() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await auth.signIn(email, password);
    } catch (err) {
      M.toast({ html: "Incorrect email and password combination" });
    }
  };

  useEffect(() => {
    if (auth.user) {
      navigate("/my");
    }
  }, [auth.user]);

  return (
    <div className="container login-container">
      <div className="card-panel login-panel">
        <div className="login-title dark-primary-color">
          <div className="row">
            <div className="col s12 text-center">
              <img
                src={`/${cavsLogo}`}
                alt="CAVS logo"
                className="login-logo"
              />
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <span className="white-text login-title">
                Cost Analysis Valuation System
              </span>
            </div>
          </div>
        </div>
        <TermsBannerComponent/>
        <div className="row vertical-padding">
          <div className="col m8 offset-m2">
            <div className="row">
              <div className="col">
                <p>
                  <span className="secondary-text-color">
                    Login using your email address and password.
                  </span>
                </p>
              </div>
            </div>
            <div className="row">
              <form className="col s12">
                <div className="row">
                  <div className="input-field col s12">
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      id="email"
                      type="email"
                      className="validate text-lowercase"
                    />
                    <label htmlFor="email">Email</label>
                  </div>
                  <div className="input-field col s12">
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      id="pass"
                      type="password"
                      className="validate"
                    />
                    <label htmlFor="pass">Password</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col m12">
                    <p className="text-center">
                      <button
                        onClick={handleSubmit}
                        className="btn btn-sm default-primary-color"
                      >
                        Login
                      </button>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <p className="text-center">
                      <span className="helper-text">
                        For the best experience using CAVS, we recommend using
                        the latest version of Chrome.
                      </span>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col m12 text-center">
                    <Link to="/forgot" className="secondary-text-color">
                      Forgot password?
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col m12 text-center">
                    <a href="/" className="secondary-text-color">
                      Home
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
